<template>
    <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
        @before-open="beforeOpen" :adaptive="true">
        <div class="modal-container">
            <div class="create-modal-header ">
                <h3>Create Key</h3>
                <button @click=close>X</button>
            </div>
            <div class="modal-content">
                <div class="modal-intro-information">
                    <label>Visitor First Name</label>
                    <input ref="title" type="text" placeholder="First Name" class="modal-title" v-model="firstName" />
                    <label>Visitor Last Name</label>
                    <input ref="title" type="text" placeholder="Last Name" class="modal-title" v-model="lastName" />
                </div>
                <div class="modal-create-data">
                    <div class="modal-create-data-item">
                        <p>Resident Name</p>
                        <input ref="resident-name" type="text" placeholder="Resident Name" class="modal-title"
                            v-model="residentUid" />
                    </div>
                    <div class="modal-create-data-item">
                        <p>License Plate Number</p>
                        <input ref="license-plate" type="text" placeholder="Visitor License Plate Number"
                            class="modal-title" v-model="licensePlate" />
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Key Active Time</p>
                        <div class="modal-create-data-item">
                            <p>Start Time</p>
                            <input ref="visitor-expiration" type="date" placeholder="Vistor Expiration Time"
                                class="visitor-modal-title" v-model="visitorExpiration" />
                        </div>
                        <div class="modal-create-data-item">
                            <p>Expiration Time</p>
                            <input ref="visitor-expiration" type="date" placeholder="Vistor Expiration Time"
                                class="visitor-modal-title" v-model="visitorExpiration" />
                        </div>
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Send Key By:</p>
                        <div class="modal-checkbox-item">
                            <input type="checkbox" />
                            <div class="modal-create-data-item">
                                <p>Visitor Phone Number</p>
                                <input ref="resident-name" type="text" placeholder="Visitor Phone Number"
                                    class="modal-title" v-model="residentUid" />
                            </div>
                        </div>
                        <div class="modal-checkbox-item">
                            <input type="checkbox" />
                            <div class="modal-create-data-item">
                                <p>Visitor Email</p>
                                <input ref="license-plate" type="text" placeholder="Visitor Email" class="modal-title"
                                    v-model="licensePlate" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button @click="() => alert('Send Key')">Send Key</button>
            </div>
        </div>
    </modal>

</template>
<script>

import * as Constants from "../../js/constants.js";

const NAME = Constants.CREATE_KEY_MODAL

export default {
    data() {
        return {
            modalName: NAME,
            firstName: "",
            lastName: "",
            residentUid: "",
            businessName: "",
            visitorPhoneNumber: "",
            visitorEmail: "",
            licensePlate: "",
        }
    },
    methods: {
        show() {
            this.$modal.show(NAME);
        },
        close() {
            this.$modal.hide(NAME);
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
        },
    }
}
</script>
<style></style>